import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchFormComponent } from './search-form.component';
import { FormControlModule } from '@shabic/form-control';
import { TranslateModule } from '@ngx-translate/core';
import { UiModule } from '@shabic/ui';
import { ReactiveFormsModule } from '@angular/forms';
import { IconModule } from '@shabic/icon';

@NgModule({
  declarations: [SearchFormComponent],
  imports: [
    CommonModule,
    FormControlModule,
    TranslateModule,
    UiModule,
    ReactiveFormsModule,
    IconModule,
  ],
  exports: [SearchFormComponent],
})
export class SearchFormModule {}
